import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {
              width: '100%',
              height: '600px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0',
              boxSizing: 'border-box',
              padding: '0 20px'
            } }
const _hoisted_5 = { style: {
                fontSize: '14px',
                position: 'relative',
                height: '120px',
                padding: '28px 24px 18px 32px',
                marginTop: '15px'
              } }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " 本报告样本，项目执⾏⼈共计21⼈。完成1-60单的1⼈，占⽐4.76%， 有效百分⽐为4.76% ", -1)
const _hoisted_8 = { style: {
                fontSize: '14px',
                position: 'relative',
                height: '120px',
                padding: '28px 24px 18px 32px'
              } }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, " 本报告样本，项目执⾏⼈共计21⼈。完成1-60单的1⼈，占⽐4.76%， 有效百分⽐为4.76% ", -1)
const _hoisted_11 = { class: "bi-tmpl-detail__right__cmpt__radioBox" }

import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModuleBackground from '../bi-pc-module/pc-module-background/index';
import { getBorderFnMap } from '../bi-pc-module/pc-module-border/index';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-1',
  setup(__props) {

const TYPE_MAPPING = [1, 2, 3, 4, 5].map(i => {
  return {
    value: 'pc-module-background-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleBackground.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, titleCmpt, pageNoCmpt, subTitleCmpt } =
  useDetailCmpt();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 675,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              class: "xrk-card",
              onClick: ($event: any) => (_unref(onChange)(item.value)),
              style: {"width":"420px","height":"600px"}
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_unref(titleCmpt))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(titleCmpt)), _mergeProps({
                      key: 0,
                      style: {"width":"1200px","transform":"scale(0.33)","transform-origin":"0 center"},
                      ref_for: true
                    }, {
                innerText: '项目背景介绍',
                enInnerText: 'Project Background Introduction'
              }), null, 16))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    innerHTML: _unref(getBorderFnMap)[item.index].fn()
                  }, null, 8, _hoisted_6),
                  _hoisted_7
                ]),
                (_unref(subTitleCmpt))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(subTitleCmpt)), _mergeProps({
                      key: 1,
                      class: "subTitleCmpt",
                      ref_for: true
                    }, {
                innerText: '项目背景'
              }), null, 16))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    innerHTML: _unref(getBorderFnMap)[item.index].fn()
                  }, null, 8, _hoisted_9),
                  _hoisted_10
                ]),
                (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)))),
                (_unref(pageNoCmpt))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageNoCmpt)), {
                      key: 2,
                      style: {"width":"60px","height":"30px"}
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_3),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(BaseRadio), {
                value: item.value,
                "model-value": _unref(curItem).value,
                onClick: ($event: any) => (_unref(onChange)(item.value))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(), 1)
                ]),
                _: 2
              }, 1032, ["value", "model-value", "onClick"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})